import { LanguageLocaleInterface } from '../localization';
import { ctaKey } from './config';

export default function(locale: LanguageLocaleInterface) {
  return `${ctaKey}__${locale.slug}`;
}
